// import _ from 'lodash';

const addresses = {
  isLoading: {
    deliveryAddresses: false,
    newAddressForm: false,
  },
  permissionAllowed: true,
  availableDeliveryAddresses: [],
  newAddressForm: {
    unitNumber: '',
    streetNumber: '',
    streetNumber2: '',
    streetName: '',
    address: '',
    suburb: '',
    state: '',
    postcode: '',
    country: 'AU',
  },
}
const AddressReducer = function (state = addresses, action) {
  switch (action.type) {
    case 'TOGGLE_DELIVERY_ADDRESS_LOADING': {
      return {
        ...state,
        isLoading: {
          ...state.isLoading,
          [action.key]: action.value,
        },
      }
    }
    case 'SET_AVAILABLE_DELIVERY_ADDRESS_PERMISSION': {
      return {
        ...state,
        permissionAllowed: action.value,
      }
    }
    case 'UPDATE_AVAILABLE_DELIVERY_ADDRESSES': {
      return {
        ...state,
        availableDeliveryAddresses: action.value,
      }
    }
    case 'UPDATE_NEW_ADDRESS_FORM': {
      return {
        ...state,
        newAddressForm: {
          ...state.newAddressForm,
          [action.key]: action.value,
        },
      }
    }
    case 'CLEAR_NEW_ADDRESS_FORM': {
      return {
        ...state,
        newAddressForm: {
          ...state.newAddressForm,
          unitNumber: '',
          streetNumber: '',
          streetNumber2: '',
          streetName: '',
          address: '',
          suburb: '',
          // state: '', // Don't change this so we will always use whatever that has been set
          postcode: '',
          // country: 'AU', // Don't change this so we will always use whatever that has been set
        },
      }
    }
    default: {
      return state
    }
  }
}

export default AddressReducer
